<div id="openBillingAccountsModal">
    <div class="modal-header">
        <h4 class="modal-title">Time To Buy Another Bundle!</h4>
    </div>
    <div class="modal-body">
        <p>Great search work! It's time to buy another bundle of searches.
            You can purchase another search bundle in the billing page of your team's settings.</p>
    </div>
    <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="close()">Close</button>
    </div>
</div>